import { Injectable, Injector, inject } from '@angular/core';
import { HateoasResourceOperation } from '@lagoshny/ngx-hateoas-client';
import { Settings } from '@shared/models/settings/settings';
import { RoleAuthorization } from '@shared/models/settings/role-authorisation';
import { ErrorDisplayService } from '@services/error-display/error-display.service';
import { TranslateService } from '@ngx-translate/core';
import { EnabledAuthMethod } from '@shared/models/settings/enabled-auth-method';
import { Role } from '@shared/models/settings/role';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import {firstValueFrom} from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SettingsService extends HateoasResourceOperation<Settings> {
    private readonly injector = inject(Injector);
    private readonly http = inject(HttpClient);

    constructor(
) {
        super(Settings);
    }

    get roleAuthorizations(): Promise<RoleAuthorization[]> {
        return this.loadSettings().then((settings) => settings.roleAuthorizations);
    }

    private _settings!: Settings;

    get settings(): Settings {
        return this._settings;
    }

    set settings(settings: Settings) {
        settings.enabledAuthenticationMethods = settings.enabledAuthenticationMethods.filter((am: EnabledAuthMethod, index: number) => {
            // Rename previously stored document template methods if needed
            if (am.authenticationMethod.toString() === 'document_template') {
                am.authenticationMethod = 'documenttemplate';
            }
            // Remove duplicate authentication methods
            return settings.enabledAuthenticationMethods.findIndex(
                (other: EnabledAuthMethod) => am.authenticationMethod === other.authenticationMethod && am.dmtService === other.dmtService
            ) === index;
        });
        this._settings = settings;
    }

    loadSettings(): Promise<Settings> {
        console.log('load settings');
        return firstValueFrom(this.getCollection({ useCache: false }))
            .then(res => {
                console.log(res);
                if (res) {
                    this.settings = res.resources[0] || null;
                }
                return this.settings;
            }).catch((error) => {
                const translate = this.injector.get(TranslateService);
                const errorDisplayService = this.injector.get(ErrorDisplayService);
                errorDisplayService.displayError(translate.instant('error.server_unavailable.title'), error.message);
                return error;
            });
    }

    createRole(role: Role) {
        return this.http.post(`${environment.springAppUrl}/user/create_role`, role);
    }

    deleteRole(role: Role) {
        return this.http.delete(`${environment.springAppUrl}/user/delete_role/${role.name}`);
    }
}
